export default "__VITE_ASSET__8d6b9695__"